<div class="select-dialog">
  <div id="dialog-title">
    <mat-icon class="title-icon" *ngIf="matIcon">
      {{matIcon}}
    </mat-icon>
    <span>
      {{ modalTitle }}
    </span>
    <mat-icon class="cancel" (click)="cancel()">close</mat-icon>
  </div>
  <div id="dialog-content">
    <ng-template #componentHost></ng-template>
  </div>
</div>
